module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_inomemado@3x-fcfe8d4a2047661bb848eb6f957e31f0.webp";